import styled from '@emotion/styled'

export const Heading = styled.div`
  color: #7b7b7b;
  font-family: Satoshi;
  font-weight: 700;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0%;
`
